import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { addStaffInternalEvent, addStaffInternalSeries, getGenericDetails, withLoading } from '../../../../../../utils';
import CModal from "../../../../../Form/CModal";
import Form from "../../../../../Form/Form";

const useStyles = makeStyles((theme) => ({
    formContainer: {
        border: '20px',
        backgroundColor: 'white',
        borderRadius: '4px',
        padding: "20px",
        maxWidth: "600px",
        width: "100vw",
        maxHeight: "80vh",
        overflowY: "auto"

    }
}))

const AddInternalEventStaffForm = (props) => {

    const alreadyUsedStaffIdSet = useMemo(() => {
        const alreadyUsedStaffIdSet = new Set()
        props.internalEventDetails.staffDetails.forEach(staffDetail => {
            alreadyUsedStaffIdSet.add(staffDetail.staffId)
        });
        return alreadyUsedStaffIdSet
    }, [props.internalEventDetails])

    const mountedRef = useRef(false)
    const [genericDetails, setGenericDetails] = useState(null)
    const businessId = useSelector((state) => { return (state.buisnessDetails.businessId) });
    const classes = useStyles()

    const fetchGenericDetails = async () => {
        const genericResponse = await withLoading(getGenericDetails, {
            businessId
        })
        if (!genericResponse.error) {
            setGenericDetails(genericResponse.genericDetails)
        }
    }

    useEffect(() => {
        if (!mountedRef.current) {
            mountedRef.current = true
        }

        if (!props.open && genericDetails) {
            setGenericDetails(null)
        }
        else if (props.open && mountedRef.current) {
            fetchGenericDetails()
        }
    }, [props.open])
    return (
        <React.Fragment>
            <CModal open={props.open} setOpen={props.setOpen}>
                <Container component="main" className={classes.formContainer}>
                    <Form
                        moreData={{
                            businessId: businessId,
                            eventId: props.internalEventDetails.eventId,
                            editTag: props.internalEventDetails.editTag,
                            seriesId: props.internalEventDetails.seriesId
                        }}
                        title="Add Staff to Internal Event(s)"
                        cancelEnabled
                        cancelAction={() => { props.setOpen(false) }}
                        submitText="Add"
                        action={async (payload) => {
                            const finalPayload = {
                                businessId: businessId,
                                eventId: props.internalEventDetails.eventId,
                                editTag: props.internalEventDetails.editTag,
                                seriesId: props.internalEventDetails.seriesId,
                                staffIds: payload.staffIds

                            }
                            if (payload.applyAll === true) {
                                return await addStaffInternalSeries(finalPayload)
                            }
                            else {
                                return await addStaffInternalEvent(finalPayload)
                            }
                        }}
                        postAction={(res) => {
                            if (res && !res.error) {
                                props.setOpen(false)
                                props.fetchInternalEventDetails()
                            }
                        }}
                        inputFields={[
                            {
                                type: "MultiSelect",
                                name: "staffIds",
                                label: "Staff",
                                validator: value => (value === null || value.length === 0 ? "Select staff to add" : null),
                                choices: genericDetails === null ? [] : genericDetails.staffDetails
                                    .filter(staffDetail => !alreadyUsedStaffIdSet.has(staffDetail.staffId))
                                    .map(staffDetail => [`${staffDetail.firstName} ${staffDetail.lastName}`, staffDetail.staffId])
                            },
                            {
                                type: "CheckBox",
                                name: "applyAll",
                                label: "Add staff to all events in series",
                                enabled: props.internalEventDetails.seriesId !== null
                            },
                        ]}
                    />
                </Container>
            </CModal>
        </React.Fragment>
    )
}

export default AddInternalEventStaffForm